import React from "react";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import Button from "@mui/material/Button";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";

export default function MobileLocationPromptModal({ onClose, assets, onRemove, onKeep }) {
  const mobileLocationNames = [
    ...new Set(
      assets.flatMap(asset =>
        (asset.rackLocations || [])
          .filter(rl => rl.mobile_warehouse_location)
          .map(rl => rl.mobile_warehouse_location.location_name)
      )
    ),
  ].filter(Boolean);

  const mobileLocationDisplay =
    mobileLocationNames.length > 0 ? mobileLocationNames.join(", ") : "a mobile location";

  return (
    <Dialog open onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle sx={{ display: "flex", justifyContent: "center" }}>
        <Typography fontSize={24} fontWeight={500} color="textPrimary" align="center">
          Attention
        </Typography>
      </DialogTitle>
      <DialogContent>
        <Box display="flex" justifyContent="center" py={2}>
          <Typography variant="body1" align="center">
            {assets.length === 1 ? "This item is" : "These items are"} currently assigned to
            mobile location <strong>{mobileLocationDisplay}</strong>.
            <br />
            Would you like to remove that mobile location or keep it?
          </Typography>
        </Box>
      </DialogContent>
      <DialogActions sx={{ justifyContent: "center", pb: 3 }}>
        <Button onClick={onRemove} variant="outlined" color="primary">
          Remove Mobile Location
        </Button>
        <Button onClick={onKeep} variant="contained" color="primary">
          Keep Mobile Location
        </Button>
      </DialogActions>
    </Dialog>
  );
}
